import {TYPES} from '../Actions/enquiryAction';

const enquiryReducer = (state = {}, action) => {
    switch (action.type) {
        case TYPES.FETCH_ALL_INSURERS_SUCCESS:
            return {
                ...state,
                allInsurers: action.allInsurers
            };
        case TYPES.ENQUIRY_SUCCESS:
            return {
                ...state,
                enquiryResult: action.enquiryResult
            };
        case TYPES.SEARCH_SUCCESS:
            return {
                ...state,
                searchResult: action.searchResult
            };
        default:
            return state;
    }
};

export default enquiryReducer;



// WEBPACK FOOTER //
// ./src/ReduxRequests/Reducer/enquiryReducer.ts